// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorAccountMedicalCoverageModels {
    static getAttributeTypeMap() {
        return PayorAccountMedicalCoverageModels.attributeTypeMap;
    }
}
PayorAccountMedicalCoverageModels.discriminator = undefined;
PayorAccountMedicalCoverageModels.additionalProperties = false;
PayorAccountMedicalCoverageModels.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payorAccountMedicalCoverageModels.js.map